import { memo } from 'react';

import { Spinner } from '@air/primitive-spinner';

import { SELECT_LOADING } from '~/constants/testIDs';

export const SelectLoadingOption = memo(() => {
  return (
    <li className="flex w-full items-center justify-start" data-testid={SELECT_LOADING}>
      <Spinner className="size-3 ads:text-icon-emphasis text-gray-12" />
      <div className="ml-1.5 font-medium ads:text-metadata text-14 text-gray-10">Loading</div>
    </li>
  );
});

SelectLoadingOption.displayName = 'SelectLoadingOption';
